import { IPageData, IPageParams } from "../types"

/**
 * $t('enum.E_FaultCaseLibraryIsPublic.No')
 * $t('enum.E_FaultCaseLibraryIsPublic.Yes')
 */
export enum E_FaultCaseLibraryIsPublic {
    /**
     * 本地
     */
    No = 1,
    /**
     * 公开
     */
    Yes = 2
}

/**
 * $t('enum.E_FaultCaseLibraryAttachType.TrendAnalysis')
 * $t('enum.E_FaultCaseLibraryAttachType.ImageAnalysis')
 * $t('enum.E_FaultCaseLibraryAttachType.Attach')
 */
export enum E_FaultCaseLibraryAttachType {
    /**
     * 趋势分析
     */
    TrendAnalysis = 1,
    /**
     * 图谱分析
     */
    SpectrumAnalysis = 2,
    /**
     * 附件
     */
    Attach = 3,
}

export interface IFaultCaseLibraryAttachVO {
    /**
     * 附件类型
     */
    attachType: E_FaultCaseLibraryAttachType
    /**
     * 附件名称
     */
    attachName?: string
    /**
     * 附件上传id
     */
    fileId: number
    fileUrl?: string
}


export interface IFaultCaseLibraryItem {
    /**
     * 附件
     */
    attachList: IFaultCaseLibraryAttachVO[]
    /**
     * 区域ID
     */
    areaId: number
    /**
     * 区域名称
     */
    areaName: string
    /**
     * 轴承型号
     */
    bearingModel: string
    /**
     * 轴承型号2
     */
    bearingModel2: string
    /**
     * 案例名称
     */
    caseName: string
    /**
     * 公司
     */
    companyId: number
    /**
     * 公司名称
     */
    companyName: string
    /**
     * 联系方式
     */
    contactInfo: string
    /**
     * 联轴器类型
     */
    couplingType: string
    /**
     * 诊断结论
     */
    diagnosisConclusion: string
    /**
     * 传动方式
     */
    driveMode: string
    /**
     * 设备ID
     */
    equipmentId: number
    /**
     * 设备名称
     */
    equipmentName: string
    /**
     * 设备转速
     */
    equipmentSpeed: number
    /**
     * 设备类型
     */
    equipmentType: string
    /**
     * 故障时间
     */
    failureTime: string
    /**
     * 故障描述
     */
    faultDesc: string
    /**
     * 故障来源
     */
    faultSource: string
    /**
     * 设备重要程度
     */
    importanceEquipment: string
    /**
     * 检修建议
     */
    maintSuggestions: string
    /**
     * 测点位置
     */
    mappingLocation: string
    /**
     * 电机转速
     */
    motorSpeed: number
    /**
     * 原因分析
     */
    reasonAnalysis: string
    /**
     * 备注
     */
    remark: string
    /**
     * 近期维修记录
     */
    repairRecord: string
    /**
     * 检修结果
     */
    repairResult: string
    /**
     * 检修/维修时间
     */
    repairTime: string
    /**
     * 采样参数设置
     */
    samplingParams: string
    /**
     * 传感器方向
     */
    sensorAxial: string
    /**
     * 传感器id
     */
    sensorId: string
    /**
     * 传感器类型
     */
    sensorType: string
    /**
     * 图谱分析
     */
    spectrumAnalysis: string
    /**
     * 趋势分析
     */
    trendAnalysis: string

    isPublic: E_FaultCaseLibraryIsPublic
}



export interface IFaultCaseLibraryDeleteParams {
    id
}

export interface IFaultCaseLibraryInfoParams {
    id
}

export interface IFaultCaseLibraryInfoData extends IFaultCaseLibraryItem {
    id: number
}

export type IFaultCaseLibraryAddParams = IFaultCaseLibraryItem


export interface IFaultCaseLibraryEditParams extends IFaultCaseLibraryItem {
    id: number
}


export type IFaultCaseLibraryListParams = IPageParams & Partial<{
    caseName: string
    companyId: number

    equipmentType: string
    equipmentName: string

    createUser: string
    startTime: string
    endTime: string

    isPublic: E_FaultCaseLibraryIsPublic
}>

export interface IFaultCaseLibraryListItem {
    areaId: number
    areaName: string
    caseName: string
    caseNo: string
    companyId: number
    companyName: string
    createTime: string
    createUser: string
    equipmentId: number
    equipmentName: string
    equipmentType: string
    failureTime: string
    id: number
    parentCompanyId: number
    updateTime: string
    updateUser: string
    isPublic: E_FaultCaseLibraryIsPublic
}

export type IFaultCaseLibraryListData = IPageData<IFaultCaseLibraryListItem>

export interface IFaultCaseLibraryGetWaveIdParams {
    /**
     * 故障编号
     */
    faultSn: string
}

export interface IFaultCaseLibraryGetWaveIdData {
    areaId
    areaName
    bearingModel
    companyId
    companyName
    diagnosisConclusion: string
    equipmentId
    equipmentName
    equipmentType
    failureTime
    maintSuggestions: string
    mappingId
    mappingLocation
    motorSpeed
    sensorAxial
    sensorId
    sensorType
}

export interface IFaultCaseLibraryGetDiagnosisNewCaseLibraryDefaultParam {
    diagnosisId: string
}

